import React from 'react'
import {useTranslation} from 'react-i18next'
import {observer} from 'mobx-react'
import {Divider, Typography} from 'antd'
import {ActionButtons} from '@/pages/components'
import {LinkActionsMenu} from '@/pages/PayByLink/components'

import {Icon, TableStatus} from '@/components'
import {
    getPayByLinkPaymentStatusExtraIconType,
    getPayByLinkPaymentStatusIconType,
    getPayByLinkPaymentStatusName,
    getPayByLinkPaymentStatusTagType
} from '~/code/pages/PayByLink/services'
import {LinkDetailsModalHeaderProps} from './props'
import styles from './styles.scss'
import {ORDER_NUMBER_WITH_STATUS} from '@/constants/playwright-ids'

const {Text} = Typography

export const LinkDetailsModalHeader: React.FC<LinkDetailsModalHeaderProps> = observer(
    ({createdPaymentLink, isMultiUse = false, onViewAllPaymentsClick}) => {
        const {t} = useTranslation()
        return (
            <div className={styles.container}>
                <div className={styles.orderNumber} data-test-id={ORDER_NUMBER_WITH_STATUS}>
                    <Text strong>
                        {t('LinkDetailsModalHeader.orderNumber')} {createdPaymentLink.invoiceId}
                    </Text>
                    <Divider type={'vertical'} />
                    <TableStatus
                        statusProps={{
                            type: getPayByLinkPaymentStatusTagType(createdPaymentLink.status),
                            iconType: getPayByLinkPaymentStatusIconType(createdPaymentLink.status),
                            status: getPayByLinkPaymentStatusName(createdPaymentLink.status)
                        }}
                        extra={
                            <Icon
                                type={getPayByLinkPaymentStatusExtraIconType(
                                    createdPaymentLink.status
                                )}
                            />
                        }
                    />

                    {isMultiUse && (
                        <>
                            <Divider type={'vertical'} />
                            <a
                                onClick={(e) => {
                                    e.stopPropagation()
                                    e.preventDefault()

                                    onViewAllPaymentsClick &&
                                        onViewAllPaymentsClick(createdPaymentLink)
                                }}
                                href='#'
                            >
                                {t('PayByLink.viewAllPayments')}
                            </a>
                        </>
                    )}
                </div>
                <ActionButtons menu={<LinkActionsMenu paymentLink={createdPaymentLink} />} />
            </div>
        )
    }
)
